var $radio = document.querySelectorAll('.fjs-nav-radio'),
	$articleWrappers = document.querySelectorAll('.fjs-article-wrapper');;
	
if($articleWrappers.length) {	
	resetWrappers();
}

if ($radio.length) {
	for(var i = 0; i < $radio.length; i++) {
		var $this = $radio[i];

		$this.addEventListener('change', setHeight);
	}
}

function setHeight() {
	var $nextSib =  this.nextElementSibling,
		$articleList = $nextSib.querySelector('.fjs-articles-list'),
		$articleWrapper = $nextSib.querySelector('.fjs-article-wrapper');

	if ($articleList && $articleWrapper) {
		var getHeight = $articleList.clientHeight;
	
		resetWrappers();

		$articleWrapper.classList.remove('js-hide-content');
	}
}

function resetWrappers() {
	for(var i = 0; i < $articleWrappers.length; i++) {
		var $this = $articleWrappers[i];

		$this.classList.add('js-hide-content');
	}
}
